/** Visibilidade de negociações por membro. */

export type DealsVisibility = "all" | "assigned_only";

export interface FilterableDeal {
  lead_id: string | null;
  owner_member_id?: string | null;
}

export function resolveDealsVisibility(raw: unknown, isAdmin: boolean): DealsVisibility {
  if (isAdmin) return "all";
  if (raw === "assigned_only" || raw === "all") {
    return raw;
  }
  return "all";
}

export function usesAssignedOnlyDeals(visibility: DealsVisibility, isAdmin: boolean): boolean {
  return !isAdmin && visibility === "assigned_only";
}

export function canSeeAllDeals(visibility: DealsVisibility, isAdmin: boolean): boolean {
  return isAdmin || visibility === "all";
}

export function isDealVisibleToMember(
  deal: FilterableDeal,
  opts: {
    isAdmin: boolean;
    currentMemberId: string | null | undefined;
    dealsVisibility: DealsVisibility;
    leadAssignedMemberId?: string | null;
  },
): boolean {
  if (opts.isAdmin) return true;
  if (opts.dealsVisibility === "all") return true;

  if (
    opts.currentMemberId &&
    deal.owner_member_id != null &&
    deal.owner_member_id === opts.currentMemberId
  ) {
    return true;
  }

  if (!deal.lead_id) return false;

  const assigned = opts.leadAssignedMemberId ?? null;
  return Boolean(
    opts.currentMemberId && assigned != null && assigned === opts.currentMemberId,
  );
}
